var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "Box",
    { attrs: { padding: 5 } },
    [
      _c(
        "Box",
        { attrs: { tag: "header", marginBottom: 5 } },
        [
          _c(
            "layoutText",
            {
              attrs: {
                fontUppercase: "",
                fontSize: 3,
                fontWeight: "bold",
                color: "#222"
              }
            },
            [_vm._v("Send Invoice via Email")]
          )
        ],
        1
      ),
      _c(
        "Box",
        { attrs: { display: "flex" } },
        [
          _c("Box", { attrs: { flex: 2 } }, [
            _c("iframe", {
              staticStyle: { width: "100%", "min-height": "600px" },
              attrs: { src: _vm.getInvoiceLink() }
            })
          ]),
          _c(
            "Box",
            { attrs: { flex: 1, marginLeft: 4 } },
            [
              _c(
                "FormRow",
                [
                  _c(
                    "layoutText",
                    {
                      attrs: {
                        fontWeight: "semibold",
                        fontSize: 2,
                        marginRight: 5
                      }
                    },
                    [_vm._v("Recepient Email:")]
                  ),
                  _c(
                    "UISelect",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { value: _vm.email },
                      on: { input: _vm.onEmailChange }
                    },
                    _vm._l(_vm.state.emails, function(email) {
                      return _c(
                        "option",
                        { key: email, domProps: { value: email } },
                        [_vm._v(_vm._s(email))]
                      )
                    }),
                    0
                  )
                ],
                1
              ),
              _c(
                "FormRow",
                [
                  _c(
                    "layoutText",
                    {
                      attrs: {
                        fontWeight: "semibold",
                        fontSize: 2,
                        marginRight: 5
                      }
                    },
                    [_vm._v("Fundraiser:")]
                  ),
                  _c(
                    "UISelect",
                    {
                      staticStyle: { width: "100%" },
                      on: { input: _vm.onFundraiserSelected },
                      model: {
                        value: _vm.state.fundraiser,
                        callback: function($$v) {
                          _vm.$set(_vm.state, "fundraiser", $$v)
                        },
                        expression: "state.fundraiser"
                      }
                    },
                    [
                      _c("option", { domProps: { value: null } }, [
                        _vm._v("Select Fundraiser")
                      ]),
                      _vm._l(_vm.fundraisers || [], function(fundraiser) {
                        return _c(
                          "option",
                          {
                            key: fundraiser.id,
                            domProps: { value: fundraiser }
                          },
                          [_vm._v(" " + _vm._s(fundraiser.name) + " ")]
                        )
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _c(
                "FormRow",
                [
                  _c(
                    "layoutText",
                    {
                      attrs: {
                        fontWeight: "semibold",
                        fontSize: 2,
                        marginRight: 5
                      }
                    },
                    [_vm._v("From Name:")]
                  ),
                  _c("UIInput", {
                    model: {
                      value: _vm.state.fromName,
                      callback: function($$v) {
                        _vm.$set(_vm.state, "fromName", $$v)
                      },
                      expression: "state.fromName"
                    }
                  })
                ],
                1
              ),
              _c(
                "FormRow",
                [
                  _c(
                    "layoutText",
                    {
                      attrs: {
                        fontWeight: "semibold",
                        fontSize: 2,
                        marginRight: 5
                      }
                    },
                    [_vm._v("From Email:")]
                  ),
                  _c("UIInput", {
                    model: {
                      value: _vm.state.from,
                      callback: function($$v) {
                        _vm.$set(_vm.state, "from", $$v)
                      },
                      expression: "state.from"
                    }
                  })
                ],
                1
              ),
              _c(
                "FormRow",
                [
                  _c(
                    "layoutText",
                    {
                      attrs: {
                        fontWeight: "semibold",
                        fontSize: 2,
                        marginRight: 5
                      }
                    },
                    [_vm._v("Email Subject:")]
                  ),
                  _c("UIInput", {
                    model: {
                      value: _vm.state.subject,
                      callback: function($$v) {
                        _vm.$set(_vm.state, "subject", $$v)
                      },
                      expression: "state.subject"
                    }
                  })
                ],
                1
              ),
              _c(
                "FormRow",
                [
                  _c(
                    "layoutText",
                    {
                      attrs: {
                        fontWeight: "semibold",
                        fontSize: 2,
                        marginRight: 5
                      }
                    },
                    [_vm._v("CC:")]
                  ),
                  _c("UIInput", {
                    model: {
                      value: _vm.state.cc,
                      callback: function($$v) {
                        _vm.$set(_vm.state, "cc", $$v)
                      },
                      expression: "state.cc"
                    }
                  })
                ],
                1
              ),
              _c(
                "FormRow",
                [
                  _c(
                    "layoutText",
                    {
                      attrs: {
                        fontWeight: "semibold",
                        fontSize: 2,
                        marginRight: 5
                      }
                    },
                    [_vm._v("BCC:")]
                  ),
                  _c("UIInput", {
                    model: {
                      value: _vm.state.bcc,
                      callback: function($$v) {
                        _vm.$set(_vm.state, "bcc", $$v)
                      },
                      expression: "state.bcc"
                    }
                  })
                ],
                1
              ),
              _c(
                "FormRow",
                [
                  _c(
                    "layoutText",
                    {
                      attrs: {
                        fontWeight: "semibold",
                        fontSize: 2,
                        marginRight: 5
                      }
                    },
                    [_vm._v("Remove Signature from Email:")]
                  ),
                  _c("UICheckbox", {
                    staticStyle: { "margin-left": "10px" },
                    model: {
                      value: _vm.state.removeSignature,
                      callback: function($$v) {
                        _vm.$set(_vm.state, "removeSignature", $$v)
                      },
                      expression: "state.removeSignature"
                    }
                  })
                ],
                1
              ),
              _c(
                "FormRow",
                [
                  _c(
                    "layoutText",
                    {
                      attrs: {
                        fontWeight: "semibold",
                        fontSize: 2,
                        marginRight: 5
                      }
                    },
                    [_vm._v("Message:")]
                  ),
                  _c("UITextarea", {
                    attrs: { placeholder: "Email text", size: "large" },
                    model: {
                      value: _vm.state.message,
                      callback: function($$v) {
                        _vm.$set(_vm.state, "message", $$v)
                      },
                      expression: "state.message"
                    }
                  })
                ],
                1
              ),
              _c(
                "UIButton",
                {
                  attrs: {
                    disabled:
                      _vm.sendingEmail ||
                      (!_vm.state.primaryEmail && !_vm.state.selectedEmail)
                  },
                  on: { click: _vm.submit }
                },
                [
                  !_vm.sendingEmail
                    ? _c("span", [_vm._v("Submit")])
                    : _c(
                        "span",
                        [
                          _vm._v(" Sending "),
                          _c("Icon", { attrs: { name: "spinner", spin: "" } })
                        ],
                        1
                      )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }